export type MailProtocolEntryDto = {
	subject: string
	sender: EmailAddress
	recipients: EmailAddress[]
	sendUnixTimestamp: number
	status: MailProtocolStatus
	statusMessage: string
	mailHtml: string
}

export type EmailAddress = {
	mail: string
	name: string
	type: EmailType
}

export enum EmailType {
	FROM = 'FROM',
	TO = 'TO',
	CC = 'CC',
	BCC = 'BCC'
}

export enum MailProtocolStatus {
	DELIVERED = 'DELIVERED',
	PENDING = 'PENDING',
	FAILED = 'FAILED'
}
